import { adminBoundariesEndpoints } from '@ooh/contracts';
import type { EndpointDef, callEndpoint } from '@ooh/contracts';

// ─── Shared auth interface ──────────────────────────────────────────────────

export interface WithCallWithAuth {
  callWithAuth: <TDef extends EndpointDef>(
    def: TDef,
    request: Parameters<typeof callEndpoint<TDef>>[1],
  ) => ReturnType<typeof callEndpoint<TDef>>;
}

// ─── Query factories ──────────────────────────────────────────────────────────

export const adminBoundaryQueries = {
  /**
   * Query factory for admin boundary import status (admin-only).
   * Mirrors transportLayerQueries.importStatus.
   */
  importStatus: (auth: WithCallWithAuth) => ({
    queryKey: ['admin-boundaries', 'import', 'status'] as const,
    queryFn: () => auth.callWithAuth(adminBoundariesEndpoints.importStatus, {}),
  }),
};
